import React, { useLayoutEffect, useRef, useState } from 'react';

const slug = (status = '') => status.trim().toLowerCase().replace(/\s+/g, '-');

const RoadmapPanel = ({ milestones = [], title = 'Roadmap' }) => {
  const total = milestones.length;

  /* Only completed counts. Pending is the opposite of done. */
  const completed = milestones.filter((m) => slug(m.status) === 'completed').length;
  const progress = total ? Math.round((completed / total) * 100) : 0;

  /* Unfinished milestones are listed first. The grey fill covers the
     rail from the top down to the first milestone that has started
     (in progress or completed), so the green shows from that dot on.
     Measured rather than a percentage, because wrapped text makes the
     nodes uneven. */
  const trackRef = useRef(null);
  const [fillHeight, setFillHeight] = useState(null);

  useLayoutEffect(() => {
    const track = trackRef.current;
    if (!track) return undefined;

    const measure = () => {
      const rail = track.querySelector('.roadmap__rail');
      const started = track.querySelector('.roadmap__dot:not(.is-pending)');
      if (!rail) return;
      if (!started) {
        setFillHeight(rail.offsetHeight);
        return;
      }
      const dot = started.getBoundingClientRect();
      const centre = dot.top + dot.height / 2;
      setFillHeight(Math.max(0, centre - rail.getBoundingClientRect().top));
    };

    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(track);
    return () => observer.disconnect();
  }, [milestones]);

  if (!total) return null;

  return (
    <section className="roadmap">
      <div className="section-head">
        <h3>{title}</h3>
        <span className="label">
          {completed} of {total} shipped
        </span>
      </div>

      <div
        className="roadmap__track"
        role="progressbar"
        aria-valuenow={progress}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={`${title} progress`}
        ref={trackRef}
      >
        <div className="roadmap__rail">
          <div
            className="roadmap__fill"
            style={{ height: fillHeight == null ? `${100 - progress}%` : `${fillHeight}px` }}
          />
        </div>

        <ol className="roadmap__nodes">
          {milestones.map((item, index) => (
            <li key={item.id ?? index} className="roadmap__node">
              <span className={`roadmap__dot is-${slug(item.status)}`} />
              <div className="roadmap__text">
                <span className="label roadmap__status">{item.status}</span>
                <span className="roadmap__desc">{item.text}</span>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default RoadmapPanel;